import React, { useEffect, useState } from 'react'
import {
  $demoContest,
  changeDemoContestStatusMounted,
  demoContestMounted,
} from './model'
import { useStore } from 'effector-react'
import { Col, Flex, Row, Typography } from 'antd'
import { CButton, CCard, CCardBody } from '@coreui/react-pro'
import { PrizesTable } from '../widgets/PrizesTable'
import { ParticipantsTable } from '../widgets/ParticipantsTable/component'
import { DemoContestStatuses } from './types'
import { ConfirmModal } from '../../copytrade/strategies/atoms/confirmModal'
import { ChangedEndedStatusModal } from '../widgets/ChangedEndedStatusModal/component'
import { Guard } from '../../../features/session/guard'

export const DemoContestDetail: React.FC = () => {
  const demoContest = useStore($demoContest)
  const [openModal, setOpenModal] = useState(false)
  const [isTeamModal, setTeamModal] = useState(false)

  useEffect(() => {
    demoContestMounted()
  }, [])

  if (!demoContest) {
    return null
  }

  const handleChangedStatus = () => {
    if (
      demoContest.status === 'ended' &&
      demoContest.contestType !== 'regular'
    ) {
      setTeamModal(true)
    } else {
      changeDemoContestStatusMounted({
        id: String(demoContest.id),
        status:
          DemoContestStatuses[
            demoContest.status as keyof typeof DemoContestStatuses
          ],
      })
    }
  }

  return (
    <div>
      <Flex justify="space-between" className="mb-3">
        <Typography.Title>{demoContest.name}</Typography.Title>
        <Guard permission="edit_status_democontest">
          <>
            {demoContest.status !== 'results' && (
              <CButton
                color="primary"
                size="sm"
                onClick={() => setOpenModal(true)}
              >
                Move to{' '}
                <strong>
                  {
                    DemoContestStatuses[
                      demoContest.status as keyof typeof DemoContestStatuses
                    ]
                  }
                </strong>{' '}
                status
              </CButton>
            )}
          </>
        </Guard>
      </Flex>
      <Row className="mb-3" gutter={16}>
        <Col span={12}>
          <Flex gap={12} vertical align="stretch">
            <CCard>
              <CCardBody>
                <Typography.Title level={3}>Data</Typography.Title>
                <Flex vertical={true}>
                  <Typography.Text>
                    Registered At: {demoContest.humanRegistrationAt}
                  </Typography.Text>
                  <Typography.Text>
                    Live At: {demoContest.humanActivatesAt}
                  </Typography.Text>
                  <Typography.Text>
                    Ended At: {demoContest.humanEndsAt}
                  </Typography.Text>
                </Flex>
              </CCardBody>
            </CCard>
            <CCard>
              <CCardBody>
                <Typography.Title level={3}>General</Typography.Title>
                <Flex vertical={true}>
                  <Typography.Text>
                    Status: {demoContest.status}
                  </Typography.Text>
                  <Typography.Text>
                    Type: {demoContest.contestType}
                  </Typography.Text>
                  <Typography.Text>
                    Participants: {demoContest.participantCount}
                  </Typography.Text>
                  <Typography.Text>Description:</Typography.Text>
                </Flex>
              </CCardBody>
            </CCard>
            <CCard>
              <CCardBody>
                <Typography.Title level={3}>
                  Technical properties
                </Typography.Title>
                <Flex vertical={true}>
                  <Typography.Text>
                    Created at: {demoContest.humanCreatedAt}
                  </Typography.Text>
                  <Typography.Text>
                    Updated at: {demoContest.humanUpdatedAt}
                  </Typography.Text>
                  <Typography.Text>
                    Manager: {demoContest?.updatedBy?.email}
                  </Typography.Text>
                </Flex>
              </CCardBody>
            </CCard>
          </Flex>
        </Col>
        <Col span={12}>
          <CCard style={{ overflow: 'auto' }}>
            <CCardBody>
              <PrizesTable prizes={demoContest.prizes} />
            </CCardBody>
          </CCard>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col span={24}>
          <CCard>
            <CCardBody>
              <Typography.Title level={3}>Participants</Typography.Title>
              <ParticipantsTable />
            </CCardBody>
          </CCard>
        </Col>
      </Row>
      <ConfirmModal
        isOpen={openModal}
        onSubmit={() => {
          handleChangedStatus()
          setOpenModal(false)
        }}
        onCancel={() => setOpenModal(false)}
      />
      <ChangedEndedStatusModal
        demoContest={demoContest}
        isVisible={isTeamModal}
        onClose={() => setTeamModal(false)}
      />
    </div>
  )
}
